<template>
  <!-- Kontener główny komponentu sortowania -->
  <div class="sort-by">
    <!-- Nagłówek sekcji z tłumaczeniem klucza 'sorting' -->
    <h3 class="margin-0">{{ t('sorting').toUpperCase() }}</h3>
    <!-- Komponent select-filter:
         - name: etykieta pola (kierunek sortowania)
         - fieldName: klucz w store.filters
         - type: identyfikator typu filtrowania
         - store: przekazanie instancji store z filtrami
         - selected: domyślnie 'desc' (malejąco)
    -->
    <select-filter
      :name="t('direction').toUpperCase()"
      fieldName="orderDirection"
      type="direction"
      :store="filtersStore"
      selected="desc"
    />
  </div>
</template>

<script>
// Import store Pinia dla bieżących filtrów
import { useCurrentFiltersStore } from "@/stores/currentFilters";
// Import komponentu select-filter używanego do wyboru opcji
import SelectFilter from "../filters/SelectFilter.vue";

export default {
  name: "SortBy",       // Nazwa komponentu
  components: { SelectFilter }, // Rejestracja komponentu potomnego
  setup() {
    // Inicjalizacja store'u z aktualnymi filtrami
    const filtersStore = useCurrentFiltersStore();
    // Zwrócenie instancji store do użycia w szablonie
    return { filtersStore };
  },
};
</script>

<style scoped>
.sort-by {
  width: 50%;
}
.sort-by h3 {
  padding: 0.85rem 1rem 0.9rem 1rem;
  border-bottom: 1px solid #bfbfbf;
}
</style>
<style>
.sort-by .form-select:active,
.sort-by .form-select:focus,
.sort-by .form-select:focus-visible {
  border: 1px solid #dedede;
  outline-width: 0;
  box-shadow: none;
}
.sort-by .form-select {
  border-radius: 0;
  height: 40px;
  font-size: 12px;
  margin: 5px 5px 5px 5px;
}

.sort-by .filter .name {
  font-size: 12px;
}
</style>